// Undo on a hands-free run's line in Board activity (Features 4, David: "the activity feed says 'Ran hands-free', with
// what changed and Undo where the board can undo it"). It is the chat's own "Undo these changes": the run's chat opens
// beside the board and that turn's changes go back, as the button under the turn does, so the chat says Undone too.
// A job keeps no chat, so its line has no Undo. The owner's alone: a shared view never gets these lines.

import type { Activity } from "../../shared/types";
import { toast } from "../state/store";
import { UndoButton } from "./UndoButton";

/** Opens the run's chat and puts back what that turn changed. */
async function undoHandsFree(to: NonNullable<Activity["handsFree"]>): Promise<void> {
  const { chat, openChat, openChatById } = await import("./store");
  const r = await openChatById(to.chat!);
  if (r !== "ok") {
    toast({ level: "warn", title: "Nothing was undone", body: r === "busy" ? "The chat on screen is still replying. Try again when it is done." : r === "gone" ? "That run's chat was deleted, so its changes can't be put back from here." : r === "offline" ? "The board could not be reached. Try again in a moment." : "Open that run's chat from the Chats list and undo it there." });
    return;
  }
  openChat();
  const run = chat.get().runs.find((x) => (to.run ? x.id === to.run : x.turn === to.turn));
  if (!run) {
    toast({ level: "warn", title: "Nothing was undone", body: "This browser didn't keep that run's changes. The chat is open: undo it there, or change it back by hand." });
    return;
  }
  if (run.undone) {
    toast({ level: "info", title: "Already undone", body: "Those changes were put back before." });
    return;
  }
  const { undoRun } = await import("./run");
  undoRun(run.id);
  toast({ level: "success", title: "Undone", body: "The run's changes are back as they were. Its chat is open beside the board." });
}

export function HandsFreeUndo({ to }: { to: NonNullable<Activity["handsFree"]> }) {
  if (!to.chat || (!to.turn && !to.run)) return null;
  return <UndoButton tip="Puts back what this run changed on the board, as Undo in its chat does" run={() => undoHandsFree(to)} />;
}
